import DownOutlined from '@ant-design/icons/DownOutlined';
import { Image, Input } from 'antd';
import { useEffect, useRef, useState } from 'react';

const SwapItem = ({
	label,
	token,
	onClick,
	tokenLogo = '/images/logo/main-logo.svg?v=1.4',
	onChangeAmount,
	amount,
	isCalculating,
	setTypeSendAmount,
	typeSendAmount,
	active,
	setConvertData
}) => {
	const [inputValue, setInputValue] = useState(amount ?? "");
	const inputRef = useRef<any>(null);

	useEffect(() => {
		setInputValue(amount ?? "");
	}, [amount]);

	const handleFocus = () => {
		if (token === "VND" && typeSendAmount !== "FIAT") {
			setTypeSendAmount("FIAT");
			onChangeAmount(0);
			setInputValue(0);
			setConvertData(prev => ({
				...prev,
				tokenAmount: 0,
				fiatAmount: 0,
				fiatReceivedAmount: 0
			}));
		}

		if (token !== "VND" && typeSendAmount !== "TOKEN") {
			setTypeSendAmount("TOKEN");
			onChangeAmount(0);
			setInputValue(0);
			setConvertData(prev => ({
				...prev,
				tokenAmount: 0,
				fiatAmount: 0,
				fiatReceivedAmount: 0
			}));
		}
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;

		if (token === "PI") {
			if (!/^\d*$/.test(value)) return;
		} else {
			if (!/^(\d+)?(\.)?(\d*)?$/.test(value)) return;
		}

		setInputValue(value);
		onChangeAmount(value);
	};

	useEffect(() => {
		if (active && inputRef.current) {
			inputRef.current.focus({ cursor: 'end' });
		}
	}, [active]);

	return (
		<div className="border border-[#ccc] rounded-lg flex flex-col gap-1 p-3">
			<p className="text-[#707A8A]">{label}</p>

			<Input
				ref={inputRef}
				suffix={
					<div className="p-2 bg-[#f6f6f7] rounded-xl flex items-center gap-2 cursor-pointer" onClick={onClick}>
						<div className="flex-shrink-0">
							<Image preview={false} src={tokenLogo} alt="coin" className="object-cover !w-5 !h-5 rounded-full" />
						</div>
						<span className="text-sm font-bold">{token}</span>
						<DownOutlined className="text-sm" />
					</div>
				}
				className="!border-none !outline-none text-lg !shadow-none !p-0"
				placeholder="0"
				value={isCalculating ? "Calculating..." : inputValue}
				onFocus={handleFocus}
				onChange={handleChange}
				// ô không-active vẫn cho focus để chuyển mode, nhưng tránh nhập lỗi do amount đã format
				readOnly={!active && !isCalculating}
			/>
		</div>
	);
};


export default SwapItem